import { CenterItem } from '@components/LinearLayout';
import { styled } from 'styled-components';

export const ScrollButtonRoot = styled(CenterItem)<{
  $size: number;
  $backgroundColor: string;
  $hoverBackgroundColor: string;
}>`
  width: ${({ $size }) => `${$size}rem`};
  height: ${({ $size }) => `${$size}rem`};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  &:hover {
    background-color: ${({ $hoverBackgroundColor }) => $hoverBackgroundColor};
    transition: all 0.2s linear;
  }
`;

export const LeftButtonWrapper = styled.div`
  z-index: 2;
  position: absolute;
  left: 2rem;
  top: 40%;
  cursor: pointer;
`;

export const RightButtonWrapper = styled.div`
  z-index: 2;
  position: absolute;
  right: 2rem;
  top: 40%;
  cursor: pointer;
`;
